import React, { useEffect, useState } from "react";
import { getFormsErrorMessage, searchFormCustomers } from "../../../api/formsApi";

export default function FormCustomerLookup({ botId, field, value, onChange, className }) {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    setResults([]);
    setError("");
    if (value || !query.trim()) {
      setLoading(false);
      return undefined;
    }
    setLoading(true);
    const timer = setTimeout(async () => {
      try {
        const rows = await searchFormCustomers(botId, query.trim());
        if (active) setResults(rows || []);
      } catch (err) {
        if (active) setError(getFormsErrorMessage(err, "Could not search records. Please try again."));
      } finally {
        if (active) setLoading(false);
      }
    }, 250);
    return () => { active = false; clearTimeout(timer); };
  }, [botId, query, value]);

  return <div className="relative sm:col-span-2">
    <label className="block text-sm font-semibold text-slate-700">
      {field.label}{field.required && <span className="ml-1 text-rose-700">*</span>}
      <input className={`${className} mt-1`} required={field.required} readOnly={Boolean(value)} value={value || query} placeholder="Search name, phone or email" autoComplete="off" onChange={(event) => setQuery(event.target.value)} />
    </label>
    {value && <button type="button" className="mt-1 text-xs font-semibold text-cyan-800" aria-label={`Clear ${field.label}`} onClick={() => { onChange(""); setQuery(""); }}>Change selection</button>}
    {!value && query.trim() && <div className="mt-1 border border-slate-200 bg-white">
      {loading ? <p role="status" className="p-2 text-xs text-slate-500">Searching records...</p> : error ? <p role="alert" className="p-2 text-xs text-rose-700">{error}</p> : results.length ? results.map((record) => <button key={record.id} type="button" disabled={!record.name} title={!record.name ? "This record has no name to insert." : undefined} className="block w-full border-b border-slate-100 p-2 text-left text-sm hover:bg-cyan-50 disabled:opacity-50" onClick={() => { onChange(record.name); setQuery(""); }}>{record.name || "Unnamed"} · {record.phone || "No phone"} · ID {record.id}</button>) : <p className="p-2 text-xs text-slate-500">No matching records.</p>}
    </div>}
    <p className="mt-1 text-xs text-slate-500">Select an existing record. Its name is saved in this form; the patient remains unchanged.</p>
  </div>;
}
